import request from '@/config/axios'

/** 订单状态标签 */
export const ORDER_STATUS_LABELS: Record<number, string> = {
  10: '待支付',
  20: '已支付/待履约',
  30: '服务中',
  40: '已完成',
  50: '已取消',
  60: '已退款'
}

/** 取消方标签 */
export const ORDER_CANCEL_BY_LABELS: Record<number, string> = {
  0: '用户',
  1: '师傅',
  2: '平台'
}

/** 预约订单 VO（监管视图，价格单位：分） */
export interface OrderVo {
  id: number
  orderNo: string
  status: number
  userId: number
  userName?: string
  masterId: number
  masterName?: string
  serviceName: string
  slotDate: string
  startTime: string
  endTime: string
  price: number
  payTime?: string
  cancelBy?: number
  cancelReason?: string
  completeTime?: string
  createTime?: string
}

export const OrderApi = {
  // 订单分页（师傅/会员/状态筛选）
  getPage: (params: { pageNo?: number; pageSize?: number; masterId?: number; userId?: number; status?: number }) => {
    return request.get({ url: '/xuanxue/order/page', params })
  },
  // 订单详情
  get: (id: number) => {
    return request.get({ url: '/xuanxue/order/get', params: { id } })
  },
  // 退款干预（已支付/服务中 → 已退款；未履约单同时释放时段）
  refund: (id: number, reason: string) => {
    return request.put({ url: '/xuanxue/order/refund', params: { id, reason } })
  }
}
